import { render, staticRenderFns } from "./PortalContentTypeKey.vue?vue&type=template&id=ed13de52&"
import script from "./PortalContentTypeKey.vue?vue&type=script&lang=js&"
export * from "./PortalContentTypeKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed13de52')) {
      api.createRecord('ed13de52', component.options)
    } else {
      api.reload('ed13de52', component.options)
    }
    module.hot.accept("./PortalContentTypeKey.vue?vue&type=template&id=ed13de52&", function () {
      api.rerender('ed13de52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/PortalContentTypeKey.vue"
export default component.exports